import React from "react";
import { commaIcon } from "../../../assets/icons";
import { founderProfile } from "../../../assets/images";

const Founder = () => {
  return (
    <div className="client_satisfaction wrapper_founder_details spacing ">
      <div className="container">
        <div className="page_title">
          <h2>Built by a Visionary, Backed by Science</h2>
          <p>
            Built by a doctor who understands what women need and brings her
            years of medical science expertise and deep empathy into every
            feature of the Women’s Health tracker app.
          </p>
        </div>
        <div className="review_card">
          <div className="image_wrap">
            <img src={founderProfile} alt="profile-image" />
          </div>
          <div className="content">
            <p className="text">
              <img src={commaIcon} alt="icon" />
              <b className="founder">Meet Our Founder - Dr. Ila Kathuria</b>
              <p>
                At the heart of Holypills lies the vision and expertise of Dr.
                Ila Kathuria, a distinguished name in women’s health and one of
                India’s foremost advocates of personalized, integrative care.
                With over 35 years of clinical experience, Dr. Kathuria has
                consistently challenged the status quo in women’s healthcare by
                blending the depth of homeopathy with the precision of modern
                medical insight.
              </p>
              <p>
                As one of the only gynecology-focused homeopaths in the country,
                Dr. Kathuria has stood as a visionary in a fragmented healthcare
                landscape—one where women often struggle to find cohesive,
                whole-person care. She founded Holypills to close this gap—a
                digital health ecosystem that brings together evidence-based
                tracking, alternative medicine, and compassionate conversation.
                Through Holypills, she aims to deliver the kind of care that
                truly listens, understands, and evolves with every woman’s
                journey.
              </p>
              <p>
                With Holypills, Dr. Kathuria takes her vision even further by
                integrating AI-driven guidance—blending her clinical expertise
                with smart digital tools. The result is AI-powered, personalized
                care crafted by women, for women , making daily wellness support
                more intuitive, empathetic, and actionable than ever before.
              </p>
              <p>
                At Holypills, her vision is not just to treat—but to transform.
                Every tracker, every conversation with Holy (the in-app
                companion), and every treatment plan echoes her deep-rooted
                belief:{" "}
                <i>
                  {" "}
                  Women deserve care that is as complex, intuitive, and
                  resilient as they are.
                </i>
              </p>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Founder;
